import './PlayNextItem.css';
import React from 'react';
import { CasinoThumbnail } from '../../../GameThumbnails/Casino/CasinoThumbnail';
import { useDeviceTypeHook } from '../../../../../../shared/src/hooks/use-device-type.hook';

export const PlayNextItem = ({ game, onClickHandler }) => {
    const { isCoarsePointer } = useDeviceTypeHook();

    return (
        <div className="game-page-header-play-next-list__item casino-vertical-grid__item--small">
            <CasinoThumbnail
                id={game.id}
                name={game.name}
                images={game.images}
                badges={[]}
                overlayBadges={[]}
                openGameHandler={() => { onClickHandler(game); }}
                isMobile={isCoarsePointer}
                thumbnailSize="small"
                displayNameOnStripsGridUI={true}
            />
        </div>
    );
};
